import { Button, Stack, Typography } from "@mui/material";
import errorAsset from "../assets/error.svg";
import { it } from "../locales";

const locales = it.onfidoErrorPage;
export const ErrorMessage = () => {
  return (
    <Stack justifyContent="center" alignItems="center" flex={1}>
      <Typography variant="subtitle" mb={11}>
        {locales.title}
      </Typography>
      <img src={`${errorAsset}`} alt="Errore" />
      <Typography variant="body" mt={5} mb={7}>
        {locales.text}
      </Typography>
      <Button
        variant="primary"
        onClick={() => window.location.reload()}
        sx={{ px: 9 }}
      >
        {locales.cta}
      </Button>
    </Stack>
  );
};
